<template>
    <div class="main">
        <c-panel title="LOCAIS DE LOTAÇÃO" titleIcon="fas fa-map-marker-alt">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Local físico onde o servidor exerce a função."
                description="É diferente da escola: o servidor pode exercer na SMED, num setor da secretaria ou num órgão externo — lugares que não existem no cadastro de instituições."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="10">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar local..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="24" :sm="8">
                    <el-select v-model="filtro.tipo" clearable placeholder="Tipo" style="width: 100%;" @change="carregar">
                        <el-option v-for="t in tipos" :key="t" :value="t" :label="rotulo(t)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/lotacao-fisica/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVO LOCAL</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Local</th>
                            <th style="width: 140px;">Tipo</th>
                            <th class="hidden-mobile">Escola vinculada</th>
                            <th style="width: 100px;" class="u-text-center">Situação</th>
                            <th style="width: 120px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="l in items" :key="l.id">
                            <td>{{ l.nome }}<div v-if="l.endereco"><small class="u-text-muted">{{ l.endereco }}</small></div></td>
                            <td>{{ rotulo(l.tipo) }}</td>
                            <td class="hidden-mobile">{{ l.instituicao ? l.instituicao.nome : '—' }}</td>
                            <td class="u-text-center">{{ l.situacao ? 'Ativo' : 'Inativo' }}</td>
                            <td class="u-text-center acao">
                                <router-link v-if="podeEscrever" :to="'/admin/lotacao-fisica/edit/' + l.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(l.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="5" class="u-text-center">Nenhum local cadastrado.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO G — item 27. Interface para `api/local-lotacao`. */
export default {
    data: () => ({
        statusList: false, filtro: { nome: '', tipo: '' }, items: [],
        tipos: ['escola', 'secretaria', 'setor', 'externo']
    }),
    computed: {
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () { this.carregar() },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/local-lotacao/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        rotulo (t) {
            return { escola: 'Escola', secretaria: 'Secretaria', setor: 'Setor', externo: 'Órgão externo' }[t] || t
        },
        excluir (id) {
            this.$confirm('Excluir este local de lotação?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/local-lotacao/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Local excluído.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
